"use strict";
// A Typescript interpretation of the JSON spec from
// http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf
Object.defineProperty(exports, "__esModule", { value: true });
// ENFORCED (💪) indicates that the field is enforced by the type system, and it should be impossible for any type
// assignable to T to fail JSON validation because of constraints that this field introduces.
// For example, the required field on objects is ENFORCED because a type assignable to T is guaranteed to contain all
// fields marked required.
// PARTIALLY ENFORCED (🔓) indicates that the field is partially enforced by the type system, but it may be possible
// to assign a type to T that fails validation against s.
// For example, arrays with the additionalItems parameter are PARTIALLY ENFORCED becuase (currently) every element in
// the validated type can be assigned to the additionalItems type, when only items after items.length should be
// validated against this schema.
// NOT ENFORCED (⚠️) indicates that the field is not enforced by the type system. This is either because it's
// impossible to do so efficiently given Typescript, or because I haven't figured out how yet.
// If the latter, hopefully I've included a comment.
// For example, the pattern constraint in a string type is NOT ENFORCED because there's no reasonable way to express a
// type that means "a string that matches this regex".
// NO ENFORCEMENT NEEDED (🤷) (means that this field does not add any constraints to a JSON schema so is essentially a
// comment.
// NOT SUPPORTED (❌) means you can't currently define a TsjsonSchema that includes this validation keyword :(
// Symbol needed to compile a program that passes typechecking but still fails schema validation.
// This would be much nicer as a unique symbol but we run into issues exporting schemas
// when we do that. Ideas welcome!
exports.InternalTypeSymbol = "#__internaltype__#";
exports.createSchema = (schema) => {
    return schema;
};
